// src/icons/ActivityIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
function ActivityIcon({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 20,
    viewBox: "0 0 16 20",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx("path", {
        clipRule: "evenodd",
        d: "M4.45095 5.5117C4.73428 3.67008 6.05393 1.87404 8.09191 1.52088C7.87 3.93585 9.16508 6.22092 10.9827 7.70813C11.7822 8.36225 12.5567 9.12287 13.1274 9.94975C13.6986 10.7773 14.0416 11.6357 14.0416 12.5C14.0416 14.4344 13.3821 15.9313 12.3284 16.9455C11.7028 17.5476 10.9213 17.9959 10.0213 18.2617C10.3223 17.8622 10.4999 17.3306 10.4999 16.6667C10.4999 14.6204 9.66248 12.5742 8.67308 11.4419C8.43837 11.1733 8.05572 11.3873 8.03086 11.7431C7.94516 12.9702 7.30981 13.6392 6.6972 14.2842C6.08728 14.9263 5.49989 15.5448 5.49989 16.6667C5.49989 17.2843 5.72388 17.8497 6.09505 18.2859C3.77124 17.6208 2.36883 15.7411 1.94609 13.6274C1.55658 11.6799 1.95462 10.1547 2.30891 9.44618C2.46328 9.13744 2.33815 8.76202 2.02941 8.60765C1.72068 8.45328 1.34525 8.57842 1.19088 8.88715C0.711819 9.84525 0.276544 11.6535 0.720367 13.8726C1.34807 17.0111 3.85096 19.7917 7.9999 19.7917C10.0418 19.7917 11.8718 19.12 13.1952 17.8461C14.5224 16.5687 15.2916 14.7323 15.2916 12.5C15.2916 11.2998 14.8162 10.1961 14.1562 9.23973C13.4957 8.28274 12.6263 7.4378 11.7743 6.74069C10.0428 5.32399 8.99677 3.20252 9.40747 1.14904C9.50396 0.6666 9.13159 0.192803 8.61205 0.212508C5.48704 0.331034 3.58739 2.90426 3.21549 5.32163C2.98407 6.82588 3.3324 8.09555 3.73237 8.9812C3.93249 9.42431 4.14729 9.77555 4.31407 10.0185C4.39762 10.1401 4.46958 10.2353 4.52233 10.302C4.54872 10.3353 4.57035 10.3616 4.58628 10.3806L4.6058 10.4035L4.61215 10.4107L4.61443 10.4133L4.61534 10.4144C4.61534 10.4144 4.6161 10.4152 5.08323 10L4.6161 10.4152C4.84543 10.6732 5.24047 10.6965 5.49846 10.4671C5.75591 10.2383 5.77959 9.8444 5.55178 9.58638L5.55068 9.58513L5.54295 9.57601C5.53466 9.56616 5.5209 9.5495 5.50253 9.52629C5.46576 9.47983 5.41077 9.40737 5.34457 9.31096C5.21187 9.11767 5.03605 8.83089 4.87158 8.46671C4.54238 7.73778 4.26571 6.71579 4.45095 5.5117Z",
        fill: "currentColor",
        fillRule: "evenodd"
      })
    ]
  });
}
export {
  ActivityIcon
};
//# sourceMappingURL=ActivityIcon.mjs.map